'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeObj = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.objectEmpty = objectEmpty;
exports.objPresent = objPresent;

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function objectEmpty(obj) {
  return Object.keys(obj).length === 0 || !Object.values(obj).some(function (c2) {
    return _index2.default.exists(c2);
  });
}

function objPresent(item) {
  return _lodash2.default.isObject(item) && Object.values(item).some(function (i) {
    return _index2.default.exists(i);
  });
}

var composeObj = exports.composeObj = function composeObj() {
  for (var _len = arguments.length, objs = Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }

  var obj = {};

  objs.forEach(function (o) {
    obj = _extends({}, obj, o || {});
  });

  return obj;
};